@if (isContainerVisible) {
  <div class="sidebar_container" (click)="closeSidebar()">
    <div
      class="sidebar_content"
      (click)="keepSidebarOpened($event)"
      [@sidebarAnimation]
      *ngIf="visibleTab === 3 || visibleTab === 4"
      [ngClass]="{ notification_sidebar: visibleTab === 3 }"
    >
      <div class="sidebar" *ngIf="visibleTab === 4">
        <div class="sidebar_header">
          <mat-icon class="notranslate close_icon" (click)="closeSidebar()"
            >close</mat-icon
          >
        </div>

        <div class="pinploy_image_rating_container">
          <div class="img_rating_flex">
            <div class="img_container">
              @if (!user.profileImg) {
                <mat-icon
                  (click)="closeSidebar('indstillinger/konto/profil-indstillinger')"
                  class="notranslate profile_icon"
                  >account_circle</mat-icon
                >
              } @else {
                <img 
                (click)="closeSidebar('indstillinger/konto/profil-indstillinger')"
                src="{{ user.profileImg }}" class="profile_image" />
              }
            </div>

            <div>
              <div class="name_row">
                <p class="greetings">{{ greetingString }}</p>
                <h5 (click)="closeSidebar('indstillinger/konto/profil-indstillinger')">{{ user.firstName }}</h5>
                @if (user.stripe_verified) {
                  <mat-icon
                    class="notranslate"
                    [matTooltip]="'PAGES.SETTINGS.PROFILE.VERIFIED' | translate"
                  >
                    verified_user
                  </mat-icon>
                }
              </div>

              @if (user.rating !== 0) {
                <div class="stars_container">
                  <app-svg-star
                    class="notranslate"
                    [size]="'17px'"
                    *ngFor="
                      let star of [0.5, 1.5, 2.5, 3.5, 4.5];
                      let i = index
                    "
                    [active]="star <= user.rating"
                  ></app-svg-star>
                  <div class="rate_number">
                    {{ user.rating | number: '1.1-1' : 'en-US' }}
                  </div>
                </div>
              }

              @if (
                storage?.userSettings?.pinployeeOrTaskOwner !== 'to' &&
                user.completionRate !== 0
              ) {
                <div style="padding-top: 4px">
                  <p>
                    {{ 'COMPONENTS.SIDEBAR.ACCOUNT.COMP_RATE' | translate }}
                    {{ user.completionRate }}%
                  </p>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Sidebar Tabs -->
        <div class="sidebar_body">
          <div class="handyhand_toggle_container">
            <div
              class="handyhand_toggle toggle_1"
              (click)="toggleHandyhandSettingsTab(false)"
              [ngClass]="{ isActiveToggle: !showHandyhandTab }"
            >
              <p>{{ 'COMPONENTS.SIDEBAR.ACCOUNT.HEADER' | translate }}</p>
            </div>
            <div
              class="handyhand_toggle"
              (click)="toggleHandyhandSettingsTab(true)"
              [ngClass]="{ isActiveToggle: showHandyhandTab }"
            >
              <p>
                {{ 'COMPONENTS.SIDEBAR.ACCOUNT.FOR_HANDYHANDERS' | translate }}
              </p>
            </div>
          </div>
          <!-- Cancellation Guard Rail - Account at Risk -->
          @if (cancellationGuardrail) {
            <app-cancellation-guardrail></app-cancellation-guardrail>
          }
          @if (!showHandyhandTab) {
            <div>
              @for (tab of sideBarTabs; track $index) {
                <div
                  class="sidebar_tab"
                  (click)="handleSideBarClick(tab)"
                  [ngClass]="{ has_sub_menu: tab.subMenu }"
                >
                  <div class="sidebar_tab_container">
                    <div class="icon_text">
                      <img [src]="tab.svg" alt="{{ tab.translation }}" />
                      <p>
                        {{ tab.translation | translate }}
                      </p>
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.19461 3.86201C8.45496 3.60166 8.87707 3.60166 9.13742 3.86201L13.1374 7.86201C13.3978 8.12236 13.3978 8.54447 13.1374 8.80482L9.13742 12.8048C8.87707 13.0652 8.45496 13.0652 8.19461 12.8048C7.93426 12.5445 7.93426 12.1224 8.19461 11.862L11.0565 9.00008H3.33268C2.96449 9.00008 2.66602 8.7016 2.66602 8.33341C2.66602 7.96522 2.96449 7.66675 3.33268 7.66675H11.0565L8.19461 4.80482C7.93426 4.54447 7.93426 4.12236 8.19461 3.86201Z"
                        fill="#AFC2C9"
                      />
                    </svg>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div>
              <div>
                @for (tab of sidebarTabsHandyhands; track $index) {
                  <div class="sidebar_tab" (click)="closeSidebar(tab.url)">
                    <div class="sidebar_tab_container">
                      <div class="icon_text">
                        <p>
                          {{ tab.translation | translate }}
                        </p>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.19461 3.86201C8.45496 3.60166 8.87707 3.60166 9.13742 3.86201L13.1374 7.86201C13.3978 8.12236 13.3978 8.54447 13.1374 8.80482L9.13742 12.8048C8.87707 13.0652 8.45496 13.0652 8.19461 12.8048C7.93426 12.5445 7.93426 12.1224 8.19461 11.862L11.0565 9.00008H3.33268C2.96449 9.00008 2.66602 8.7016 2.66602 8.33341C2.66602 7.96522 2.96449 7.66675 3.33268 7.66675H11.0565L8.19461 4.80482C7.93426 4.54447 7.93426 4.12236 8.19461 3.86201Z"
                          fill="#AFC2C9"
                        />
                      </svg>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <div class="sidebar" *ngIf="visibleTab === 3">
        <div class="sidebar_header">
          <div class="my_account">
            <mat-icon class="notranslate">notifications</mat-icon>
            <h5>{{ 'COMPONENTS.SIDEBAR.NOTIFICATIONS.HEADER' | translate }}</h5>
          </div>
          <div (click)="markNotifReadAll()" class="mark-notifications">
            <p>{{ 'PAGES.SETTINGS.NOTIFICATIONS.READ_ALL' | translate }}</p>
            <mat-icon class="readAll">done_all</mat-icon>
          </div>
          <mat-icon class="notranslate close_icon" (click)="closeSidebar()"
            >close</mat-icon
          >
        </div>

        <div class="sidebar_body">
          @if (
            newTaskNotifications.length === 0 && otherNotifications.length === 0
          ) {
            <p class="helper">
              {{ 'COMPONENTS.SIDEBAR.NOTIFICATIONS.HELPER' | translate }}
            </p>
          }

          <!-- Pagination -->
          <div
            [infiniteScrollDistance]="3"
            [infiniteScrollThrottle]="100"
            [alwaysCallback]="true"
            [scrollWindow]="false"
            [fromRoot]="true"
            (scrolled)="loadNextNotification()"
            class="notification-results"
            infiniteScroll
          >
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
              <!-- Tab for notifications regarding everything else -->
              <mat-tab>
                <ng-template mat-tab-label>
                  {{ 'COMPONENTS.SIDEBAR.NOTIFICATIONS.HEADER' | translate }}
                  @if (getUnreadNotificationCount() > 0) {
                    <span class="unread-count"
                      >{{ getUnreadNotificationCount() }}
                      @if (getUnreadNotificationCount() >= 20) {
                        +
                      }
                    </span>
                  }
                </ng-template>
                <ng-container
                  *ngFor="let notification of otherNotifications; let i = index"
                >
                  <div
                    class="notification_wrapper"
                    [ngClass]="{ old: notification.isRead }"
                  >
                    <div class="notification"
                         (click)="openPage(notification)">
                      <div class="icon_col">
                        <mat-icon
                          class="notranslate"
                          [ngClass]="{ bellIsRead: notification.isRead }"
                        >
                          notifications
                        </mat-icon>
                      </div>
                      <div class="text_col" id="{{ i }}">
                        <p class="notif_title" >
                          {{ notification.title }}
                        </p>
                        <p class="notif_description">
                          {{ notification.message }}
                        </p>
                        <p class="notif_date">
                          {{ notification.createdAt | dateAgo }}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </mat-tab>

              <!-- Tab for notifications regarding tasks -->
              <mat-tab>
                <ng-container *ngIf="newTaskNotifications.length === 0">
                  <div class="empty-new-task-notif">
                    <a routerLink="/indstillinger/konto/opgave-alarm">
                      {{
                        'COMPONENTS.SIDEBAR.NOTIFICATIONS.EMPTY_NEW_TASKS'
                          | translate
                      }}
                    </a>
                  </div>
                </ng-container>
                <ng-template mat-tab-label>
                  {{ 'COMPONENTS.SIDEBAR.NOTIFICATIONS.NEW_TASKS' | translate }}
                  @if (getUnreadTaskNotificationCount() > 0) {
                    <span class="unread-count"
                      >{{ getUnreadTaskNotificationCount() }}
                      @if (getUnreadTaskNotificationCount() >= 20) {
                        +
                      }
                    </span>
                  }
                </ng-template>
                <ng-container
                  *ngFor="
                    let notification of newTaskNotifications;
                    let i = index
                  "
                >
                  <div
                    class="notification_wrapper"
                    [ngClass]="{ old: notification.isRead }"
                  >
                    <div class="notification"
                         (click)="openPage(notification)"
                    >
                      <div class="icon_col">
                        <mat-icon
                          class="notranslate"
                          [ngClass]="{ bellIsRead: notification.isRead }"
                        >
                          notifications
                        </mat-icon>
                      </div>
                      <div class="text_col" id="{{ i }}">
                        <p class="notif_title">
                          {{ notification.title }}
                        </p>
                        <p class="notif_description">
                          {{ notification.message }}
                        </p>
                        <p class="notif_date">
                          {{ notification.createdAt | dateAgo }} -
                          {{ notification?.task?.city }}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
}
